<template>
  <div class="wrap-error">
    <div class="custom-error">
      <div class="error-img">!</div>
      <h1>요청하신 페이지를 찾을 수 없습니다.</h1>
      <p>방문하시려는 페이지를 찾을 수 없습니다.<br>
        입력하신 주소가 정확한지 다시 한번 확인해주세요.<br>동일한 문제가 지속적으로 발생할 경우
        <STRONG><U>고객센터
        <span v-if="store.mediaServiceNumber">{{`(${store.mediaServiceNumber})`}}</span>
        </U></STRONG>로 문의하여 주십시오.
      </p>
    </div>
  </div>
</template>

<script setup>
// const isLocalEnvironment = window.location.hostname === 'localhost';
// const basePath = isLocalEnvironment ? '/css/user/' : `${window.location.origin}${process.env.VUE_APP_WEB_CONTEXT_PATH}css/user/`;
// console.log(window.location.origin + process.env.VUE_APP_WEB_CONTEXT_PATH);

import { useUserStore } from '@/store'
const store = useUserStore();


const basePath = `${process.env.VUE_APP_WEB_CONTEXT_PATH}css/user/`;

// 동적으로 <link> 태그를 추가하여 CSS 파일 로드
const linkElement = document.createElement('link');
linkElement.rel = 'stylesheet';
linkElement.href = basePath + 'origin_style.css';

// <head> 태그에 <link> 요소 추가
document.head.appendChild(linkElement);
</script>

<style scoped>

</style>
